import React, { Component } from "react";
import "./../assets/css/App.css";
import SearchResults from "./searchResults.js";
import SelectBox from "./selectBox";
import { api, getTableWithFormular } from "./helper.js";
import SearchResultLoader from "./searchResultLoader";

class Form extends Component {
  constructor(props) {
    super(props);

    this.state = {
      country: "any",
      subject: "any",
      language: "any",
      selectedSearch: "",
      filteredResults: this.props.partnerResults,
      showResults: true,
      loading: false,
    };
    this.filterResults = this.filterResults.bind(this);
    this.changeHandler = this.changeHandler.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.partnerResults !== prevProps.partnerResults) {
      this.setState({ filteredResults: this.props.partnerResults });
    }
  }

  //Timer function meant to delay airtable query execution
  timer = (ms) => new Promise((res) => setTimeout(res, ms));

  //This function picks the first five (5) ids, get their details through AirTable API then waits for
  // 150 milliseconds before running the next five ids till the array is empty
  // This is done to prevent Airtable's Error 429 (too_many_requests)

  async getUniverstiesResponse(partnerUniversitiesIds) {
    let universitiesResponse = [];
    const ids = [...partnerUniversitiesIds];
    while (ids.length > 0) {
      const universityIds = ids.splice(0, 5).flat();
      const apiResponse = api.getTables(universityIds);
      await apiResponse
        .then((response) => {
          universitiesResponse.push(response);
        })
        .catch((err) => {
          console.error("Not found ", err);
        });
      await this.timer(150);
    }
    return universitiesResponse;
  }

  async filterResults(e) {
    e.preventDefault();
    const { country, language, subject } = this.state;

    // Get Default State before filtering
    const initialResults = this.props.partnerResults;

    const filterByFormulaSubject = `TRIM(subject)="${subject}"`;

    const filterByFormulaCountry = `TRIM(country)="${country}"`;

    const filterByFormulaEnglish = `TRIM(language)="English"`;

    const filterByFormulaNotEnglish = `Not(TRIM(language)="English")`;

    // If no filter is specified, return the default state
    if (country === "any" && language === "any" && subject === "any") {
      this.setState({ filteredResults: initialResults });
    } else {
      this.setState({ loading: true });
      let filterQueryArr = [];

      // Adding language filter query
      if (language !== "any") {
        if (language === "English") {
          filterQueryArr.push(filterByFormulaEnglish);
        } else {
          filterQueryArr.push(filterByFormulaNotEnglish);
        }
      }

      // Adding Country filter query
      if (country !== "any") {
        filterQueryArr.push(filterByFormulaCountry);
      }

      // Adding Subject filter query
      if (subject !== "any") {
        filterQueryArr.push(filterByFormulaSubject);
      }

      //Convert the filter query Array into String and add to API
      const filterQuery = encodeURIComponent(
        `AND(${filterQueryArr.join(",")})`
      );

      // Get Filtered Results from API using getTableWithFormular helper function
      await getTableWithFormular("subject_university", filterQuery)
        .then(async (response) => {
          if (response.status === 200) {
            const { records } = response.data;
            const partnerUniversitiesIds = records
              //Only accept objects with partner_university values
              .filter((el) => {
                return el.fields.partner_university;
              })
              .map((el) => el.fields.partner_university)
              //Join and split to seprate multiple partner univerisity IDs in the same array.
              .join(",")
              .split(",")
              .map((el) => `partner_universities/${el}`)
              //make Array unique
              .filter((x, i, a) => a.indexOf(x) === i);

            /** To avoid Error 429 (too_many_requests).
             * A wait time is needed for subsequent requests to be successful
             * Since the rate limit per base is 5 requests per second
             * See https://support.airtable.com/docs/en/airtable-api-common-troubleshooting for more info
             * */
            const universitiesPromises = await this.getUniverstiesResponse(
              partnerUniversitiesIds
            );

            return universitiesPromises;
          }
        })
        .then((universitiesPromises) => {
          Promise.all(universitiesPromises).then((response) => {
            const partnerResults = response.flat().map((el) => el.data);
            this.setState({ filteredResults: partnerResults }, () => {
              // Remove Loader
              this.setState({ loading: false });
            });
          });
        })
        .catch((err) => {
          this.props.sendError(err);
        });
    }
  }

  changeHandler(e) {
    this.setState({
      ...this.state,
      [e.target.name]: e.target.value,
    });
  }

  render() {
    return (
      <div>
        <div className="globalopps-filter-container">
          <form onSubmit={this.filterResults}>
            <div className="globalopps-flex">
              <SelectBox
                changeHandler={this.changeHandler}
                defaultText="All departments"
                label="Owning department"
                name="subject"
                options={this.props.subjectData}
                selectedValue={this.state.subject}
              />
              <SelectBox
                changeHandler={this.changeHandler}
                defaultText="All countries"
                label="Location"
                name="country"
                options={this.props.countryData}
                selectedValue={this.state.country}
              />
            </div>
            <p>
              <strong>Language you can study in</strong>
            </p>
            <div className="globalopps-flex">
              <div className="globalopps-flex">
                <label>
                  <input
                    type="radio"
                    name="language"
                    value="any"
                    checked={this.state.language === "any"}
                    onChange={this.changeHandler}
                  />
                  Show all
                </label>
                <label>
                  <input
                    type="radio"
                    name="language"
                    value="English"
                    checked={this.state.language === "English"}
                    onChange={this.changeHandler}
                  />
                  English
                </label>
                <label>
                  <input
                    type="radio"
                    name="language"
                    value="Modern language"
                    checked={this.state.language === "Modern language"}
                    onChange={this.changeHandler}
                  />
                  Modern language
                </label>
              </div>
              <input type="submit" value="Filter results" />
            </div>
          </form>
        </div>
        {this.state.showResults && this.state.filteredResults ? (
          <h2 className="ga-results-count">{`${this.state.filteredResults.length} results`}</h2>
        ) : null}
        {this.state.loading ? (
          <div>
            <SearchResultLoader />
            <SearchResultLoader />
          </div>
        ) : (
          <SearchResults
            partnerResults={this.state.filteredResults}
            isDisabled={this.state.showResults}
          />
        )}
      </div>
    );
  }
}

export default Form;



// WEBPACK FOOTER //
// ./src/components/form.js